// Which side of a policy a device sits on has no backend enum: the API takes a hasPolicy boolean.
// The UI still wants a radio with labels, so the mapping owns the translation back to it.
export const POLICY_DEVICE_MEMBERSHIP = {
  WithPolicy: 'withPolicy',
  WithoutPolicy: 'withoutPolicy',
};

const POLICY_DEVICE_MEMBERSHIP_MAPPING = [
  { value: POLICY_DEVICE_MEMBERSHIP.WithPolicy, label: 'With Policy', hasPolicy: true },
  { value: POLICY_DEVICE_MEMBERSHIP.WithoutPolicy, label: 'Without Policy', hasPolicy: false },
];

export const getPolicyDeviceMembershipOptions = () =>
  POLICY_DEVICE_MEMBERSHIP_MAPPING.map(({ value, label }) => ({ value, label }));

// Anything unrecognised reads as the default, devices with the policy.
export const toHasPolicy = value =>
  POLICY_DEVICE_MEMBERSHIP_MAPPING.find(item => item.value === value)?.hasPolicy ?? true;
